document.addEventListener('DOMContentLoaded', () => {
    // Helper function to calculate payments for a given term
    function calculatePayments(totalPrice, term) {
        if (totalPrice <= 0 || term <= 0) {
            return { monthly: 0, first: 0 };
        }

        // 全ての回数で共通のロジック
        const monthlyPayment = Math.floor(totalPrice / term / 100) * 100; // 100円単位で切り捨て
        const totalPaidByMonthly = monthlyPayment * (term - 1);
        const firstPayment = totalPrice - totalPaidByMonthly;

        return { monthly: monthlyPayment, first: firstPayment };
    }

    // コンテナ要素を取得
    const $container = document.querySelector('[data-js="installment-simulation"]');
    if (!$container) return;

    // data属性から金額を取得（Shopify Liquidから渡された値）
    const rawPrice = $container.getAttribute('data-product-price');
    // Shopifyの価格はセント単位（100倍）で渡されるため、100で割って円単位に戻す
    let productPrice = parseInt(rawPrice, 10) || 0;
    productPrice = Math.floor(productPrice / 100);

    // productPriceが0の場合の処理
    if (productPrice === 0) {
        const simulationContainerHTML = `
            <div class="simulation-container" data-js="simulation-container">
                <p class="price-main" style="font-size: 16px; margin: 0;">価格はお問い合わせください</p>
            </div>
        `;
        $container.insertAdjacentHTML('beforeend', simulationContainerHTML);
        return;
    }

    // paymentTermsの定義
    const paymentTerms = [36, 60, 84, 100];

    // 月々3000円以上の支払いが可能な最大の回数を探す
    const sortedTerms = [...paymentTerms].sort((a, b) => b - a);
    const validMaxTerm = sortedTerms.find(term => calculatePayments(productPrice, term).monthly >= 3000);

    let simulationContainerHTML = '';
    if (validMaxTerm) {
        // 最大回数払いの場合の月々のお支払い金額を計算
        const paymentsMax = calculatePayments(productPrice, validMaxTerm);

        // HTMLのテンプレートを定義
        simulationContainerHTML = `
            <div class="simulation-container" data-js="simulation-container">
                <p class="small-text">無金利分割払いなら</p>
                <p class="price-main">月々<span>${paymentsMax.monthly.toLocaleString()}</span>円から購入可能</p>
                <p class="note">※${validMaxTerm}回払いの場合。初回のみ${paymentsMax.first.toLocaleString()}円。</p>
                <button data-js="open-simulation-modal" class="button">お支払いシミュレーションを見る</button>
            </div>
        `;
    }

    const simulationModalHTML = `
        <div data-js="simulation-modal" class="simulation-modal-overlay">
            <div class="simulation-modal-content">
                <button data-js="close-simulation-modal" class="simulation-modal-close-button">&times;</button>
                <h2>お支払いシミュレーション</h2>
                <p class="simulation-note">金利手数料はどのお支払回数でも<span class="highlight-free">無料</span>です</p>
                <table class="simulation-table">
                    <thead>
                        <tr>
                            <th>回数</th>
                            <th class="payment-amount-header">お支払い金額</th>
                            <th>初回お支払い金額</th>
                        </tr>
                    </thead>
                    <tbody data-js="simulation-table-body">
                        <!-- Dynamic rows will be inserted here -->
                    </tbody>
                </table>
                <a href="https://www.orico.co.jp/consumer/charge/free/" target="_blank" rel="noopener" class="info-link">詳しくはこちら（オリコ公式サイト）</a>
            </div>
        </div>
    `;

    // DOMにHTMLを挿入
    document.querySelector('[data-js="installment-simulation"]').insertAdjacentHTML('beforeend', simulationContainerHTML);
    document.body.insertAdjacentHTML('beforeend', simulationModalHTML);

    // フォームのHTMLを生成（info-linkクラスを適用してボタンスタイルにする）
    const oricoFormHTML = `
        <div class="orico-form-container" style="text-align: center; margin-top: 24px;">
            <form action="https://order.orico.co.jp/weborder/start.do" method="post" target="_blank">
                <input name="DESCRIPTION_ID" type="hidden" value="S000">
                <input name="KAMEI_NO" type="hidden" value="15683006">
                <input name="KYAKU_SYU" type="hidden" value="900">
                <input type="submit" value="詳しくはこちら（オリコ公式サイト）" class="info-link">
            </form>
        </div>
    `;

    // モーダル内のテーブルの後にフォームを挿入
    const $modalContent = document.querySelector('.simulation-modal-content');
    if ($modalContent) {
        // 既存のリンクを削除（もしあれば）
        const $existingLink = $modalContent.querySelector('a.info-link');
        if ($existingLink) {
            $existingLink.remove();
        }
        $modalContent.insertAdjacentHTML('beforeend', oricoFormHTML);
    }

    // シミュレーションテーブルを動的に生成
    let tableBodyHTML = '';

    paymentTerms.forEach(term => {
        const payments = calculatePayments(productPrice, term);
        if (payments.monthly >= 3000) { // 3000円以上の支払いの場合のみ行を追加
            tableBodyHTML += `
                <tr>
                    <td>${term}回</td>
                    <td class="payment-amount-cell">${payments.monthly.toLocaleString()}円</td>
                    <td>${payments.first.toLocaleString()}円</td>
                </tr>
            `;
        }
    });

    // 全てのプランが3000円未満だった場合のメッセージ
    if (tableBodyHTML === '') {
        tableBodyHTML = `
            <tr>
                <td colspan="3" style="text-align: center; padding: 1rem;">
                    月々のお支払い金額が3,000円未満となるため、該当する支払いプランはありません。
                </td>
            </tr>
        `;
        // simulationContainerHTMLを非表示にする
        const $simulationContainer = document.querySelector('[data-js="simulation-container"]');
        if ($simulationContainer) {
            $simulationContainer.classList.add('hidden');
        }
    }

    // 生成したテーブルボディを挿入
    const $simulationTableBody = document.querySelector('[data-js="simulation-table-body"]');
    if ($simulationTableBody) {
        $simulationTableBody.innerHTML = tableBodyHTML;
    }

    // HTML挿入後に要素を取得してイベントリスナーを設定
    const $openModalButton = document.querySelector('[data-js="open-simulation-modal"]');
    const $closeModalButton = document.querySelector('[data-js="close-simulation-modal"]');
    const $modal = document.querySelector('[data-js="simulation-modal"]');

    // モーダルを開く
    $openModalButton.addEventListener('click', (e) => {
        e.preventDefault();
        $modal.classList.add('is-visible');
        document.body.classList.add('no-scroll');
    });

    // モーダルを閉じる（ボタン）
    $closeModalButton.addEventListener('click', (e) => {
        e.preventDefault();
        $modal.classList.remove('is-visible');
        document.body.classList.remove('no-scroll');
    });

    // モーダルを閉じる（背景クリック）
    $modal.addEventListener('click', (e) => {
        if (e.target === $modal) {
            e.preventDefault();
            $modal.classList.remove('is-visible');
            document.body.classList.remove('no-scroll');
        }
    });
});
